import styled from 'styled-components';
import AppBar from '@material-ui/core/AppBar';

import { patientPageWidth } from '../../constant';

export const StyledAppBar = styled(AppBar)`
    ${({ padding }) => `
    box-shadow: none;

    padding: ${padding ? padding : '0'};

    max-width: ${patientPageWidth};
    `}
`;
